const appEnv = process.env.REACT_APP_ENVIRONMENT as 'dev' | 'prod';

export { appEnv };
